module.exports = __webpack_public_path__ + "teqbahn-assets/media/logo_bg.3ddc22a9.png";